import React from 'react';

function CalendarDayCell({
  date,
  dayNumber,
  inCurrentMonth,
  dayEvents,
  blackoutEntries,
  coverageEntries,
  onOpenPersonWorkspace = null
}) {
  const visibleEvents = dayEvents.slice(0, 2);
  const hiddenCount = Math.max(dayEvents.length - visibleEvents.length, 0);
  const getChipLabel = (event) => {
    if (event.displaySubtitle) {
      return event.displaySubtitle;
    }

    const eventType = String(event.eventType || '').toLowerCase();
    if (eventType === 'sick_call') {
      return 'Sick';
    }
    if (eventType === 'other_absence') {
      return 'Absent';
    }
    if (eventType === 'late_arrival') {
      return 'Late';
    }
    return event.timeBlock;
  };

  const getChipTitle = (event) => event.displayTitle || event.displayName || event.managerName || 'Employee';

  const getChipClassName = (event) => {
    const eventType = String(event.eventType || '').toLowerCase();
    return `shared-calendar-event-chip ${eventType || String(event.timeBlock || '').toLowerCase().replace(/\s+/g, '-')}`;
  };

  return (
    <div className={`shared-calendar-day ${inCurrentMonth ? '' : 'outside-month'} ${blackoutEntries.length ? 'has-blackout' : ''}`}>
      <div className="shared-calendar-day-header">
        <span className="shared-calendar-day-number">{dayNumber}</span>
        <div className="shared-calendar-day-header-meta">
          {dayEvents.length > 0 ? <span className="shared-calendar-event-count">{dayEvents.length}</span> : null}
          {coverageEntries.length > 0 && <span className="shared-calendar-coverage-dot" title="Coverage rule exists for this day">Limit</span>}
        </div>
      </div>

      {blackoutEntries.length > 0 && (
        <div className="shared-calendar-blackout-list">
          {blackoutEntries.map(policy => (
            <div className="shared-calendar-blackout-chip" key={`${date}-${policy.id}`}>
              Blocked {policy.timeBlock}
            </div>
          ))}
        </div>
      )}

        <div className="shared-calendar-event-list">
        {visibleEvents.map(event => (
          (event.employeeProfileId || event.managerId) && typeof onOpenPersonWorkspace === 'function' ? (
            <button
              type="button"
              className={`${getChipClassName(event)} shared-calendar-event-chip--interactive`}
              key={`${date}-${event.id}`}
              onClick={() => onOpenPersonWorkspace(event)}
            >
              <strong title={getChipTitle(event)}>{getChipTitle(event)}</strong>
              <span title={getChipLabel(event)}>{getChipLabel(event)}</span>
            </button>
          ) : (
            <div className={getChipClassName(event)} key={`${date}-${event.id}`}>
              <strong title={getChipTitle(event)}>{getChipTitle(event)}</strong>
              <span title={getChipLabel(event)}>{getChipLabel(event)}</span>
            </div>
          )
        ))}
        {hiddenCount > 0 && (
          <div className="shared-calendar-more-chip">+{hiddenCount} more</div>
        )}
      </div>
    </div>
  );
}

export default CalendarDayCell;
